import { Text } from '@ecoinvent/ui';

interface StepIndicatorProps {
  totalSteps: number;
  currentStep: number;
}

const StepIndicator = ({ totalSteps, currentStep }: StepIndicatorProps) => {
  return (
    <Text fontSize="sm">
      {currentStep + 1}/{totalSteps + 1}
    </Text>
  );
};

export default StepIndicator;
